import { createFileRoute } from '@tanstack/react-router';
import { UninvoicedDispatchesReport } from '../../../features/reports/screens/UninvoicedDispatchesReport';

/** Owned by G25. Report #8 — uninvoiced dispatches. */
export const Route = createFileRoute('/_authenticated/reports/uninvoiced-dispatches')({
  component: UninvoicedDispatchesReport,
});
